import React from "react";
import Navbar from "@/components/Navbar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Trash2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const destructionCalls = [
  { title: "Retire Outdated Curriculum Frameworks Not Aligned to Current Standards", rationale: "Misalignment causes instructional gaps and assessment mismatches." },
  { title: "Remove Pre-2015 Accreditation Self-Study Templates", rationale: "No longer reflect current institutional effectiveness criteria." },
  { title: "Delete Unvalidated Student Retention Models Without Outcome Data", rationale: "Cannot be trusted for predictive analytics or institutional planning." },
  { title: "Deactivate Legacy LMS Course Shells Without Active Enrollment", rationale: "Clutter and confusion in digital learning environments." },
  { title: "Eliminate Duplicative FERPA Guidance Documents Across Departments", rationale: "Inconsistent interpretations of compliance requirements." },
  { title: "Remove Teacher Evaluation Rubrics Based on Discontinued Frameworks", rationale: "Outdated performance criteria lead to unfair assessments." },
  { title: "Sunset Financial Aid Processing Procedures Pre-FAFSA Simplification", rationale: "Obsolete workflows create compliance risk." },
  { title: "Remove CTE Pathway Maps Not Aligned to Current Industry Standards", rationale: "Graduates enter workforce with outdated competencies." },
  { title: "Discard IEP Templates Missing Current Legal Requirements", rationale: "Non-compliance with IDEA and state special education mandates." },
  { title: "Eliminate Safety Protocols Missing Modern Threat Assessment Procedures", rationale: "Non-compliant with current school safety best practices." },
];

const EducationCallForDestruction = () => {
  const navigate = useNavigate();

  const handleCallClick = (callTitle: string, rationale: string) => {
    navigate("/call-for-destruction/bounty", {
      state: {
        selectedArea: "Education Operations",
        chevronCall: {
          title: callTitle,
          rationale,
          organization: "Education Channel",
          bountyAmount: "0",
          bountyType: "Community",
          contributors: ["Education Channel", "Giblet"],
          description: `Education Channel requests the removal of outdated content: ${callTitle}. Rationale: ${rationale}`,
        },
      },
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <Link to="/education-channel">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Education Channel
            </Button>
          </Link>
          <h1 className="text-4xl font-bold text-foreground mb-4">Education Demonstration</h1>
          <p className="text-lg text-muted-foreground max-w-4xl mb-6">
            These are triggered when knowledge is outdated, duplicated, biased, or potentially harmful to learners.
          </p>
        </div>

        <Card className="mb-8">
          <CardHeader className="pb-6">
            <CardTitle className="flex items-center gap-2 text-2xl">
              <Trash2 className="h-6 w-6" />
              Calls for Destruction (CfD)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid gap-4">
              {destructionCalls.map((call, index) => (
                <Card key={index} className="border border-muted hover:border-destructive/20 transition-colors">
                  <CardContent className="p-6">
                    <button
                      className="text-lg font-semibold text-foreground hover:text-primary transition-colors cursor-pointer text-left"
                      onClick={() => handleCallClick(call.title, call.rationale)}
                    >
                      CfD: {call.title}
                    </button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EducationCallForDestruction;
